import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer-dark">
      <h2>Created by Shahzaib Irfan</h2>
    </footer>
  );
};

export default Footer;
